import { useMemo } from "react";
import { Input } from "@/components/ui/input";

function readPause(rawContent) {
  const content = rawContent || {};
  const pause = content.editorial_pause && typeof content.editorial_pause === "object"
    ? content.editorial_pause
    : {};
  return {
    eyebrow: pause.eyebrow ?? content.eyebrow ?? "",
    quote: pause.quote ?? content.quote ?? "",
    attribution: pause.attribution ?? content.caption ?? "",
  };
}

export function EditorialPauseEditor({ block, onPatch }) {
  const pause = useMemo(() => readPause(block.content), [block.content]);
  const patch = (delta) => onPatch({
    content: {
      ...(block.content || {}),
      editorial_pause: { ...pause, ...delta },
    },
  });

  return (
    <div className="rounded-2xl border hairline bg-white p-4 space-y-4"
         data-testid="editorial-pause-editor">
      <div className="text-[10px] uppercase tracking-widest opacity-70">
        Пауза · тихий разворот
      </div>
      <div>
        <label className="block text-[11px] opacity-60 mb-1">Метка · необязательно</label>
        <Input value={pause.eyebrow}
               onChange={(event) => patch({ eyebrow: event.target.value })}
               placeholder="ПАУЗА"
               data-testid="editorial-pause-eyebrow" />
      </div>
      <div>
        <label className="block text-[11px] opacity-60 mb-1">Цитата</label>
        <textarea rows={5} value={pause.quote}
                  onChange={(event) => patch({ quote: event.target.value })}
                  className="w-full rounded border px-3 py-2 font-serif text-lg leading-relaxed"
                  placeholder="Короткая мысль между главами…"
                  data-testid="editorial-pause-quote" />
      </div>
      <div>
        <label className="block text-[11px] opacity-60 mb-1">Автор или подпись · необязательно</label>
        <Input value={pause.attribution}
               onChange={(event) => patch({ attribution: event.target.value })}
               data-testid="editorial-pause-attribution" />
      </div>
    </div>
  );
}

export function EditorialPauseRender({ block, mode }) {
  const pause = readPause(block.content);
  return (
    <section
      className={`${mode === "mobile" ? "min-h-[360px] px-7 py-14" : "min-h-[440px] px-12 py-20"} flex items-center justify-center overflow-hidden bg-cream/45`}
      data-testid="editorial-pause-render"
    >
      <div className="mx-auto max-w-3xl text-center">
        {pause.eyebrow && (
          <div className="mb-7 text-[10px] uppercase tracking-[0.3em] opacity-55">
            {pause.eyebrow}
          </div>
        )}
        {pause.quote && (
          <blockquote className={`${mode === "mobile" ? "text-[24px]" : "text-[36px]"} break-words font-serif leading-snug text-espresso [overflow-wrap:anywhere]`}>
            {pause.quote}
          </blockquote>
        )}
        {pause.attribution && (
          <div className="mt-8 text-xs uppercase tracking-[0.2em] opacity-60">
            {pause.attribution}
          </div>
        )}
      </div>
    </section>
  );
}
